import { Button, Controller, TextEditor, useForm } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { Comment as CommentIcon } from '@otp/icons';

export type Form = {
  comment: string;
};

type CommentFormProps = {
  onSave: (form: Form) => void;
  loading: boolean;
  data?: Form;
};

export const CommentForm = ({ onSave, loading, data }: CommentFormProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'common.comments.form',
  });

  const { control, handleSubmit, setValue, reset } = useForm<Form>({
    defaultValues: data,
  });

  const onSubmit = handleSubmit((formData) => {
    onSave(formData);
    reset();
  });

  return (
    <div className="w-full my-4">
      <form onSubmit={onSubmit}>
        <Controller
          name="comment"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextEditor {...field} defaultValue={field.value} />
          )}
        />
        <Button
          type="submit"
          variant="outlined"
          fullWidth={true}
          className="mt-2"
          disabled={loading}
        >
          <CommentIcon className="mr-2" /> {t('submit')}
        </Button>
      </form>
    </div>
  );
};
